import { render } from "./WikiPage.vue?vue&type=template&id=39679cda&scoped=true"
const script = {}

import "./WikiPage.vue?vue&type=style&index=0&id=39679cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39679cda"]])

export default __exports__